import { Skeleton } from '@mui/material'
import styled from 'styled-components';

export const SkeletonChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 520px;
  height: 520px;
  padding: 40px;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
`;

export const SkeletonChartTitle = styled(Skeleton)`
  && {
    margin-bottom: 24px;
  }
`;

export const SkeletonChart = styled(Skeleton)`
  && {
    border-radius: 50%;
    flex-shrink: 0;
  }
`;